import { QueryDocumentSnapshot, serverTimestamp, SnapshotOptions } from "firebase/firestore";
import { auth } from "../services/firebase";

export type ServiceType =
    | "sunday-morning"
    | "sunday-afternoon"
    | "saturday"
    | "wednesday"
    | "weekday-special"
    | "manual";

export type SlotMode = "sermon" | "intro" | "reminder";

export default class PlannedSermon {
    date: string; // YYYY-MM-DD
    weekday: string;
    serviceType: ServiceType;
    serviceLabel: string;
    sermon1PreacherName: string;
    sermon1PreacherKey: string;
    sermon1Mode: SlotMode;
    sermon2PreacherName: string;
    sermon2PreacherKey: string;
    sermon2Mode: SlotMode;
    verkuendiger: string;
    guestPreacherOrigin: string;
    afternoonEvent: string;
    choirInfo: string;
    serviceNote: string;
    importedBy: string;
    importedAt: Date;

    constructor(
        date: string,
        weekday: string,
        serviceType: ServiceType,
        serviceLabel: string,
        sermon1PreacherName: string,
        sermon1PreacherKey: string,
        sermon1Mode: SlotMode,
        sermon2PreacherName: string,
        sermon2PreacherKey: string,
        sermon2Mode: SlotMode,
        importedBy: string,
        importedAt: Date,
        verkuendiger: string = "",
        guestPreacherOrigin: string = "",
        afternoonEvent: string = "",
        choirInfo: string = "",
        serviceNote: string = ""
    ) {
        this.date = date;
        this.weekday = weekday;
        this.serviceType = serviceType;
        this.serviceLabel = serviceLabel;
        this.sermon1PreacherName = sermon1PreacherName;
        this.sermon1PreacherKey = sermon1PreacherKey;
        this.sermon1Mode = sermon1Mode;
        this.sermon2PreacherName = sermon2PreacherName;
        this.sermon2PreacherKey = sermon2PreacherKey;
        this.sermon2Mode = sermon2Mode;
        this.verkuendiger = verkuendiger;
        this.guestPreacherOrigin = guestPreacherOrigin;
        this.afternoonEvent = afternoonEvent;
        this.choirInfo = choirInfo;
        this.serviceNote = serviceNote;
        this.importedBy = importedBy;
        this.importedAt = importedAt;
    }
}

export const plannedSermonConverter = {
    toFirestore: (sermon: PlannedSermon) => {
        return {
            date: sermon.date,
            weekday: sermon.weekday,
            serviceType: sermon.serviceType,
            serviceLabel: sermon.serviceLabel,
            sermon1PreacherName: sermon.sermon1PreacherName,
            sermon1PreacherKey: sermon.sermon1PreacherKey,
            sermon1Mode: sermon.sermon1Mode,
            sermon2PreacherName: sermon.sermon2PreacherName,
            sermon2PreacherKey: sermon.sermon2PreacherKey,
            sermon2Mode: sermon.sermon2Mode,
            verkuendiger: sermon.verkuendiger,
            guestPreacherOrigin: sermon.guestPreacherOrigin,
            afternoonEvent: sermon.afternoonEvent,
            choirInfo: sermon.choirInfo,
            serviceNote: sermon.serviceNote,
            importedBy: auth.currentUser?.uid ?? "",
            importedAt: serverTimestamp(),
        };
    },

    fromFirestore: (snapshot: QueryDocumentSnapshot, options: SnapshotOptions) => {
        const data = snapshot.data(options);
        return new PlannedSermon(
            data.date,
            data.weekday ?? "",
            data.serviceType ?? "manual",
            data.serviceLabel ?? "",
            data.sermon1PreacherName,
            data.sermon1PreacherKey,
            data.sermon1Mode ?? "sermon",
            data.sermon2PreacherName,
            data.sermon2PreacherKey,
            data.sermon2Mode ?? "sermon",
            data.importedBy,
            data.importedAt?.toDate() ?? new Date(),
            data.verkuendiger ?? "",
            data.guestPreacherOrigin ?? "",
            data.afternoonEvent ?? "",
            data.choirInfo ?? "",
            data.serviceNote ?? ""
        );
    },
};
